import type { ReactElement } from 'react';
import styled from 'styled-components';
import React from 'react';

const Image = styled.img`
  max-width: none;
  width: 2rem;
  height: 2rem;
`;

const RCALogo = (): ReactElement => (
  <Image
    src="/listing-ui-assets/img/rca-logo-no-text.svg"
    alt="realcommercial.com.au logo"
    title="Commercial property for sale and lease"
  />
);

export default RCALogo;
